import React from 'react'
import { View, StyleSheet } from 'react-native'
import { Text } from '@libs/components'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@libs/theme'

const SupportSection = ({
  children,
  style,
  title,
  titleStyle,
  contentStyle,
}) => {
  const { colors } = useTheme()
  const { t } = useTranslation()

  return (
    <View style={[styles.rightContainer, style]}>
      <View style={{ paddingHorizontal: 20, paddingVertical: 32 }}>
        <Text
          variant="display1"
          style={[
            {
              color: colors.textPrimary,
              fontSize: 20,
              fontWeight: 700,
            },
            titleStyle,
          ]}
        >
          {title}
        </Text>
        <View style={styles.divider} />

        <Text
          variant="display4"
          color={colors.neutral}
          style={[{ width: 350, lineHeight: 21 }, contentStyle]}
        >
          {children}
        </Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  rightContainer: {
    borderRadius: 13,
    background: 'transparent',
    borderWidth: 0.2,
    borderColor: 'rgba(0, 0, 0, 0.2)',
    backgroundColor: '#DDE0EE',
    minWidth: window.innerWidth >= 1260 ? 425 : 300,
    alignSelf: 'baseline',
  },
  divider: {
    borderBottomWidth: 1,
    borderColor: 'rgba(0,0,0,0.2)',
    borderStyle: 'solid',
    opacity: 0.4,
    marginVertical: 20,
  },
  arrows: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
    gap: 12, // Adds space between arrows
    color: 'rgba(0, 0, 0, 0.83)',
  },
  arrowButton: {
    height: '1.8rem',
    width: '1.8rem',
  },
  indicatorContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  indicator: {
    width: 10,
    height: 10,
    borderRadius: 5,
  },
  activeIndicator: {
    width: 40, // Makes the active one longer
    backgroundColor: '#316AFF', // Blue color
    borderRadius: 10, // Keeps it rounded
  },
  inactiveIndicator: {
    backgroundColor: '#A0A0A0', // Gray color
  },
  disabledArrow: {
    opacity: 0.2, // Faded when disabled
  },
})

export default SupportSection
